import './nav-bar-account-buttons-component.js'

class BasicNavBarComponent extends HTMLElement {
  
  connectedCallback() {
    this.innerHTML = String.raw`
    <nav class="navbar navbar-expand-lg navbar-light fixed-top py-0 shadow-sm bg-light hidden-print">
    <div class="container-fluid">
      <a class="navbar-brand" href="#" role="button" style="padding-top:14px;padding-bottom:14px;">Beam Span Calculator</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">

        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <!-- File -->
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" id="file-dropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">File</a>
            <ul class="dropdown-menu" aria-labelledby="file-dropdown">
              <!--<li><a class="dropdown-item" href="#" id="file-menu-new-file"><i class="fa fa-fw fa-file-o"></i> New</a>
              </li>
              <li><a class="dropdown-item" href="#" id="file-menu-new-file" data-bs-toggle="modal"
                  data-bs-target="#modal-project-header-settings-dialog"><i class="fa fa-fw fa-edit"></i> Rename</a>
              </li>
              <li><a class="dropdown-item" href="#" id="file-menu-save-file"><i class="fa fa-fw fa-save"></i> Save</a>
              </li>-->
              <li><a class="dropdown-item" href="#" id="file-menu-print-file"><i class="fa fa-fw fa-print"></i>
                  Print...</a></li>
              <!--<li><a class="dropdown-item" href="#" id="file-menu-delete-file"><i class="fa fa-fw fa-trash-o"></i>
                  Delete</a></li>-->
            </ul>
          </li>

          <!-- Edit -->
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" id="edit-dropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">Edit</a>
            <ul class="dropdown-menu" aria-labelledby="edit-dropdown">
              <li><a class="dropdown-item" href="#" data-bs-toggle="modal"
                data-bs-target="#shape-and-material-dialog">Material...</a>
              </li>
              <li><a class="dropdown-item" href="#" data-bs-toggle="modal"
                data-bs-target="#shape-and-material-dialog">Shape...</a>
              </li>
              <li><a class="dropdown-item" href="#" data-bs-toggle="modal"
                data-bs-target="#span-dialog">Spans...</a>
              </li>
              <li><a class="dropdown-item" href="#" data-bs-toggle="modal"
                data-bs-target="#load-dialog">Loads...</a>
              </li>
            </ul>
          </li>
        </ul>

        <div id="project-toast"
          class="toast align-items-center text-white bg-primary top-0 start-50 translate-middle-x" role="alert"
          aria-live="assertive" aria-atomic="true">
          <div class="d-flex">
            <div class="toast-body" id='project-toast-body'></div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
              aria-label="Close"></button>
          </div>
        </div>

        <ul class="nav ms-auto mb-2 mb-lg-0 align-middle" style="margin-right:10px;" id="">
          <li class="nav-item dropdown">
            <a class="btn btn-default navbar-btn hidden-print" type="button" href="#" id="apps-dropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              Apps <i class="fa fa-th fa-fw"></i>
            </a>
            <ul class="dropdown-menu" aria-labelledby="apps-dropodown">
              <li class="text-center"><a class="btn btn-default" style="margin:5px;" href="beam-designer.html">Beam Design</a></li>
              <li class="text-center"><a class="btn btn-default" style="margin:5px;" href="anchor-bolt-designer.html">Anchor Design</a></li>
              <li class="text-center"><a class="btn btn-default" style="margin:5px;" href="footing-designer.html">Footing Design</a></li>
            </ul>
          </li>
        </ul>

        <nav-bar-account-buttons-component></nav-bar-account-buttons-component>

      </div>
    </div>

  </nav>
      `
  }
}

customElements.define('basic-nav-bar-component', BasicNavBarComponent);